import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Gift, Loader2 } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

const AffiliateRedirect = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const [referrerName, setReferrerName] = useState('');

  useEffect(() => {
    const resolveAffiliate = async () => {
      try {
        const response = await fetch(`${API}/api/r/${slug}`);
        
        if (!response.ok) {
          setError('Invalid affiliate link');
          setTimeout(() => navigate('/'), 3000);
          return;
        }
        
        const data = await response.json();
        setReferrerName(data.referrer_name);
        
        // Store referral code in localStorage for registration
        localStorage.setItem('referral_code', data.referral_code);
        localStorage.setItem('referrer_name', data.referrer_name);
        
        // Redirect to home or login page after brief delay
        setTimeout(() => {
          navigate('/login?ref=' + data.referral_code);
        }, 2000);
        
      } catch (err) {
        setError('Something went wrong');
        setTimeout(() => navigate('/'), 3000);
      }
    };
    
    resolveAffiliate();
  }, [slug, navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#FF3B30]/10 via-white to-neutral-50 flex items-center justify-center">
      <div className="text-center px-4">
        <div className="w-20 h-20 bg-[#FF3B30] rounded-2xl flex items-center justify-center mx-auto mb-6 animate-pulse">
          <Gift className="w-10 h-10 text-white" />
        </div>
        
        {error ? (
          <>
            <h1 className="text-2xl font-bold text-neutral-900 mb-2">Oops!</h1>
            <p className="text-neutral-500">{error}</p>
            <p className="text-sm text-neutral-400 mt-2">Redirecting to home...</p>
          </>
        ) : (
          <>
            <h1 className="text-2xl sm:text-3xl font-bold text-neutral-900 mb-2" style={{ fontFamily: 'Outfit' }}>
              {referrerName ? `${referrerName} invited you!` : 'Welcome to Spinser!'}
            </h1>
            <p className="text-neutral-500 mb-4">
              Enter to win FREE home upgrades
            </p>
            <div className="flex items-center justify-center gap-2 text-[#FF3B30]">
              <Loader2 className="w-5 h-5 animate-spin" />
              <span className="text-sm">Preparing your exclusive access...</span>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default AffiliateRedirect;
